export let spinner = {

  timeoutIn: 400,
  timeoutOut: 600,
  position: 'afterbegin',
  css: 'spinner',

  _visible: false,
  _timer: null,
  _cl: null,

  /**
   * Initialize the DOM.
   * @param {HTMLElement} [cont] parent container
   */
  init(cont) {
    this._create(cont);
    this._cl = document.querySelector('.' + this.css).classList;
  },

  /**
   * Create the DOM.
   * @private
   * @param {HTMLElement} [cont] parent container
   */
  _create(cont) {
    // insert the spinner before the .main element, otherwise a layout shift might occur onScrollIntoView.
    const spinner = '<div class="' + this.css + ' hidden"><div class="' + this.css + '__ring"></div></div>';
    const el = cont || document.body;
    el.insertAdjacentHTML(this.position, spinner);
  },

  /**
   * Show the spinner.
   * The spinner is only shown after a timeout (of timeoutIn), so it can be canceled (after timeoutOut) before being shown.
   */
  show() {
    if (this._timer !== null) {
      // a timer is already running
      return;
    }
    // Show the loading animation only if it takes longer than timeOutIn to load the application.
    this._timer = window.setTimeout(() => {
      document.documentElement.style.cursor = 'wait';
      this._cl.remove('hidden');
      this._visible = true;
    }, this.timeoutIn);
  },

  /**
   * Hide the spinner.
   * The spinner is hidden after a timeout (of timeoutOut). This way, when it is shown, it is shown at least for
   * the amount of time set with timeoutOut.
   */
  hide () {
    let timeout = this._visible ? this.timeoutOut : 0;
    window.setTimeout(() => {
      window.clearTimeout(this._timer);
      this._cl.add('hidden');
      this._visible = false;
      this._timer = null;
      document.documentElement.style.cursor = 'initial';
    }, timeout);
  }
};